var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMonitor(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 512,
    height: 512,
    viewBox: "0 0 512 512",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-Monitor_"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 512,
    height: 512
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Monitor_",
    "data-name": "Monitor ",
    clipPath: "url(#clip-Monitor_)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 512,
    height: 512,
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("g", {
    id: "monitor",
    transform: "translate(14.923 16.127)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_87",
    "data-name": "Path 87",
    d: "M474.715,66.148v309.98c0,17.549-13.661,31.777-30.522,31.777H38.859C22,407.9,8.336,393.677,8.336,376.128V66.148C8.336,48.6,22,34.371,38.859,34.371H444.192C461.053,34.371,474.715,48.6,474.715,66.148Z",
    fill: "#ccd8e5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_88",
    "data-name": "Path 88",
    d: "M503.665,66.148v309.98c0,17.549-14.509,31.777-32.417,31.777h-287.9l23.752-56.76L339.655,34.371H471.247C489.155,34.371,503.665,48.6,503.665,66.148Z",
    transform: "translate(-28.95)",
    fill: "#dfeaf4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_89",
    "data-name": "Path 89",
    d: "M474.715,66.8V357.647H8.337V66.8C8.337,48.891,22,34.371,38.86,34.371H444.193C461.053,34.371,474.715,48.891,474.715,66.8Z",
    fill: "#b8e9f2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_90",
    "data-name": "Path 90",
    d: "M503.665,66.8V357.647H207.1L339.655,34.371H471.247A32.422,32.422,0,0,1,503.665,66.8Z",
    transform: "translate(-28.95)",
    fill: "#d4f7fc"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_91",
    "data-name": "Path 91",
    d: "M343.454,480.173H168.547l12.487-29.218,15.131-35.384H315.836l15.131,35.384Z",
    transform: "translate(-14.475 -15.2)",
    fill: "#ccd8e5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_92",
    "data-name": "Path 92",
    d: "M330.967,450.955H181.034l15.131-35.384H315.836Z",
    transform: "translate(-14.475 -15.2)",
    fill: "#bac6d1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_93",
    "data-name": "Path 93",
    d: "M378.729,213.856V178.172l-29.951-1.977A94.239,94.239,0,0,0,335.6,144.433l19.786-22.574-25.23-25.241-4.3,3.766v.011L307.584,116.4c-.411-.267-.833-.533-1.244-.789a94.413,94.413,0,0,0-30.529-12.387l-1.977-29.94H238.161l-1.977,29.94A94.369,94.369,0,0,0,204.422,116.4L181.836,96.618l-4.222,4.21L156.6,121.858l19.8,22.574a94.483,94.483,0,0,0-13.187,31.762l-29.929,1.977v35.684l29.929,1.966a94.3,94.3,0,0,0,13.187,31.762l-19.8,22.586,8.832,8.821,16.409,16.42,22.586-19.8a94.389,94.389,0,0,0,30.984,13.009c.256.067.522.122.778.178l1.144,17.375.833,12.554h35.673l1.977-29.929a94.633,94.633,0,0,0,31.773-13.187l22.575,19.8,25.23-25.241L335.6,247.583a94.054,94.054,0,0,0,13.176-31.762ZM256,242.674c-.589,0-1.167-.011-1.744-.033a46.649,46.649,0,1,1,1.744.033Z",
    transform: "translate(-14.475)",
    fill: "#9bb9d3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_94",
    "data-name": "Path 94",
    d: "M256,249.729a55,55,0,1,1,55-55A55.058,55.058,0,0,1,256,249.729Zm0-93.329a38.332,38.332,0,1,0,38.332,38.332A38.375,38.375,0,0,0,256,156.4Z",
    transform: "translate(-14.475 -4.958)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_95",
    "data-name": "Path 95",
    d: "M265.867,325.788H232.1A8.082,8.082,0,0,1,224.229,318l-1.488-23.847a93.772,93.772,0,0,1-21.722-9.525L183.991,300.4a7.583,7.583,0,0,1-10.776-.376L149.333,274.79a8.679,8.679,0,0,1-.358-11.387L163.9,245.412a105.361,105.361,0,0,1-9.015-22.949l-22.572-1.573a8.155,8.155,0,0,1-7.366-8.314V176.9a8.155,8.155,0,0,1,7.367-8.314l22.572-1.572a105.492,105.492,0,0,1,9.016-22.957l-14.924-17.983a8.679,8.679,0,0,1,.351-11.384l23.895-25.246a7.583,7.583,0,0,1,10.766-.369l17.031,15.763a93.912,93.912,0,0,1,21.72-9.519l1.488-23.858a8.083,8.083,0,0,1,7.869-7.784h33.769a8.083,8.083,0,0,1,7.869,7.784l1.488,23.858a94.1,94.1,0,0,1,21.727,9.52l12.713-11.767c.08-.081.162-.16.245-.237l4.067-3.763a7.582,7.582,0,0,1,10.772.377l23.886,25.239a8.678,8.678,0,0,1,.354,11.384l-14.919,17.986a105.609,105.609,0,0,1,9.01,22.954l22.581,1.573a8.155,8.155,0,0,1,7.367,8.314v35.679a8.155,8.155,0,0,1-7.367,8.314l-22.581,1.573a105.487,105.487,0,0,1-9.01,22.948L348.989,263.4a8.678,8.678,0,0,1-.356,11.382l-23.886,25.239a7.583,7.583,0,0,1-10.776.373L296.951,284.63a93.833,93.833,0,0,1-21.727,9.525L273.735,318A8.081,8.081,0,0,1,265.867,325.788Zm-26.385-16.665h19l1.382-22.15a8.2,8.2,0,0,1,6.226-7.6,78.9,78.9,0,0,0,27.417-12.02,7.559,7.559,0,0,1,9.5.722l15.812,14.649,13.446-14.2L318.4,251.8a8.705,8.705,0,0,1-.681-10.029,88.536,88.536,0,0,0,11.369-28.959,8.039,8.039,0,0,1,7.194-6.578l20.973-1.461V184.7l-20.973-1.461a8.036,8.036,0,0,1-7.194-6.578,88.664,88.664,0,0,0-11.371-28.972,8.706,8.706,0,0,1,.684-10.026l13.858-16.706-13.442-14.2L303,121.393a7.556,7.556,0,0,1-9.487.723A79.05,79.05,0,0,0,266.092,110.1a8.2,8.2,0,0,1-6.226-7.6l-1.382-22.159h-19L238.1,102.5a8.2,8.2,0,0,1-6.226,7.6,78.893,78.893,0,0,0-27.409,12.012,7.556,7.556,0,0,1-9.49-.721l-15.827-14.649-13.441,14.208,13.866,16.709a8.705,8.705,0,0,1,.683,10.033,88.507,88.507,0,0,0-11.377,28.968,8.039,8.039,0,0,1-7.194,6.578l-20.964,1.46v20.077l20.965,1.461a8.038,8.038,0,0,1,7.194,6.578,88.387,88.387,0,0,0,11.375,28.955,8.7,8.7,0,0,1-.681,10.034L165.71,268.518l13.443,14.207,15.819-14.65a7.558,7.558,0,0,1,9.5-.719,78.752,78.752,0,0,0,27.405,12.018,8.2,8.2,0,0,1,6.226,7.6ZM315.1,99.113h0Z",
    transform: "translate(-7.461)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_96",
    "data-name": "Path 96",
    d: "M444.6,24.766H38.45C17.249,24.766,0,42.448,0,64.181v57.28a7.962,7.962,0,0,0,7.861,8.058,7.962,7.962,0,0,0,7.861-8.058V64.181c0-12.847,10.2-23.3,22.728-23.3H444.6c12.533,0,22.728,10.452,22.728,23.3V339.244H418.07a8.061,8.061,0,0,0,0,16.116h49.258v14.771c0,12.847-10.2,23.3-22.728,23.3H38.45c-12.533,0-22.728-10.452-22.728-23.3V355.36H391.867a8.061,8.061,0,0,0,0-16.116H15.722V148.323a7.962,7.962,0,0,0-7.861-8.058A7.962,7.962,0,0,0,0,148.323v221.81c0,21.733,17.249,39.415,38.45,39.415H173.162l-19.335,46.369h-37.77a8.061,8.061,0,0,0,0,16.116H366.992a8.061,8.061,0,0,0,0-16.116h-37.77l-19.335-46.369H444.6c21.2,0,38.45-17.681,38.45-39.415V64.181C483.05,42.448,465.8,24.766,444.6,24.766ZM312.124,455.916h-141.2L184.359,423.7H298.692Z",
    transform: "translate(0 0)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_97",
    "data-name": "Path 97",
    d: "M253.972,376.221a8.4,8.4,0,0,0-6.291,7.67c-.364,7.534,9.106,11.629,14.33,6.172a8.33,8.33,0,0,0-8.039-13.842Z",
    transform: "translate(-14.475 -11.973)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMonitor);
export default __webpack_public_path__ + "static/media/Monitor.26e2a8133fd8f7f6c52443281a31ee78.svg";
export { ForwardRef as ReactComponent };